// extracted by mini-css-extract-plugin
module.exports = {"statusWrapper":"src-components-ProjectSummary-StatusDropdown-styles___statusWrapper","statusOverride":"src-components-ProjectSummary-StatusDropdown-styles___statusOverride"};